import { Navigate } from "react-router-dom"
import { useUser } from "../context/UserContext"

function AdminRoute({ children }) {
  const { user } = useUser()

  if (user === null) return null
  if (user?.role !== "ADMIN") return <Navigate to="/error403" replace />

  return children
}

export default AdminRoute
